

























































import { Component, Vue } from "vue-property-decorator";
import { addListAdmin, editListAdmin, roleList } from "@/req/staffPower";
@Component
export default class Logout extends Vue {
  public modal = false;
  public roleList: any = [];
  public formInline = {
    id: "",
    account: "",
    phone: "",
    password: "",
    roleCheck: "",
    passwordCheck: "",
  };
  public ruleInline = {
    account: [
      {
        required: true,
        // message: "请输入正确密码",
        validator: this.validateAccount,
        trigger: "blur",
      },
    ],
    phone: [
      { required: true, message: "请输入手机号码", trigger: "blur" },
      {
        pattern: /^1[3456789]\d{9}$/,
        message: "手机号码格式不正确",
        trigger: "blur",
      },
    ],
    password: [
      {
        required: true,
        // message: "请输入正确密码",
        validator: this.validatePassWord,
        trigger: "blur",
      },
    ],
    passwordCheck: [
      {
        required: true,
        // message: "请输入正确密码",
        validator: this.validatePassCheck,
        trigger: "blur",
      },
    ],
    roleCheck: [
      {
        required: true,
        // message: "请选择角色",
        validator: this.validateRoleCheck,
        trigger: "change",
      },
    ],
  };
  // 账户名
  public validateAccount(rule, value, callback) {
    // const s = /^[0-9a-zA-Z]*$/g;
    const z = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
    const s = /^[a-zA-Z][-_a-zA-Z0-9]*$/g;
    if (value.length < 6) {
      callback(new Error("账号长度不能小于6位"));
    } else if (!s.test(value)) {
      callback(new Error("账号需由字母开头"));
    } else if (!z.test(value)) {
      callback(new Error("账号需由字母和数字组成"));
    } else {
      callback();
    }
  }
  // 密码验证
  public validatePassWord(rule, value, callback) {
    const s = /^[0-9a-zA-Z]*$/g;
    if (!s.test(value)) {
      callback(new Error("只允许输入字母和数字"));
    } else if (value.length < 6) {
      callback(new Error("密码长度不能小于6位"));
    } else {
      callback();
    }
  }
  // 确认密码验证
  public validatePassCheck(rule, value, callback) {
    if (value === "") {
      callback(new Error("密码不能为空"));
    } else if (value !== this.formInline.password) {
      callback(new Error("两次输入密码不符"));
    } else {
      callback();
    }
  }
  // 确认角色
  public validateRoleCheck(rule, value, callback) {
    if (value == "" && value != undefined) {
      callback(new Error("角色不能为空"));
    } else {
      callback();
    }
  }
  public show() {
    this.getRoleList();
    const name = "formInline";
    (this as any).$refs[name].resetFields();
    this.formInline.id = "";
    this.formInline.account = "";
    this.formInline.phone = "";
    this.formInline.password = "";
    this.formInline.passwordCheck = "";
    this.formInline.roleCheck = "";
    this.modal = true;
  }
  // 提交验证
  public confirm(name) {
    (this.$refs[name] as any).validate((valid) => {
      if (valid) {
        this.getAddSubAccount();
      }
      //  else {
      //   console.log(valid)
      //   this.$Message.error("Fail!");
      // }
    });
  }
  public async getAddSubAccount() {
    const obj: any = {
      token: this.$fn.cookies.getToken("token"),
      role_id: this.formInline.roleCheck,
      username: this.formInline.account,
      password: this.formInline.password,
      repassword: this.formInline.passwordCheck,
      phone: this.formInline.phone,
    };
    const res = await addListAdmin(obj);
    if (res.code === 0) {
      this.$emit("getList");
      this.$Message.success(res.msg);
      this.modal = false;
    }
  }
  public async getRoleList() {
    const res = await roleList({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      this.roleList = res.data;
    }
  }
}
